import {
  Autocomplete,
  Box,
  FormControl,
  MenuItem,
  styled,
  TextField,
  Typography
} from "@mui/material";
import { allowedCountries, countries } from "../../utils/countryRatesMapping";
import useThemeColor from "../../utils/useTheme";

const StyledFormControl = styled(FormControl)({
  marginBottom: "30px",
  width: "100%"
});

function CountryDropdown({ value, onChange, style }) {
  const styles = useThemeColor();
  // Find the country object based on the country code value
  const selectedCountry =
    value && allowedCountries?.includes(value)
      ? countries.find((country) => country.code === value) || {
          name: "United States",
          code: "US",
          flag: "🇺🇸"
        }
      : {
          name: "United States",
          code: "US",
          flag: "🇺🇸"
        };

  return (
    <StyledFormControl variant="outlined" style={style}>
      {/* <StyledInputLabel sx={{ mb: 3 }} id="country-dropdown-label">
        Country
      </StyledInputLabel> */}
      <Autocomplete
        id="country-dropdown"
        options={countries}
        getOptionLabel={(option) => option.name || ""}
        value={selectedCountry}
        onChange={(event, newValue) => {
          onChange(newValue ? newValue.code : "");
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Country"
            placeholder="Search country"
            variant="outlined"
            InputLabelProps={{ style: { color: styles.color } }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#333333"
                },
                "&:hover fieldset": {
                  borderColor: "#555555"
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#777777"
                }
              }
            }}
            InputProps={{
              ...params.InputProps,
              style: { color: styles.color, borderColor: "#333333" } // 🟢 text inside input
            }}
          />
        )}
        renderOption={(props, option) => (
          <MenuItem {...props}>
            <Box display="flex" alignItems="center" width="100%">
              <Typography
                variant="body1"
                style={{ marginRight: "8px", fontSize: "20px" }}
              >
                {option.flag}
              </Typography>
              <Box flexGrow={1}>
                <Typography variant="body1">{option.name}</Typography>
              </Box>
              <Typography variant="body2" color="textSecondary">
                {option.code}
              </Typography>
            </Box>
          </MenuItem>
        )}
      />
    </StyledFormControl>
  );
}

export default CountryDropdown;
